import {Routes} from '@angular/router';
import {MobileComponent} from './mobile/mobile.component';
import {MonthComponent} from './month/month.component';
import {
    RecommendationDetailsComponent
} from './day/recommendations/recommendation-details/recommendation-details.component';
import {SearchComponent} from './search/search.component';
import {ImprintComponent} from "./imprint/imprint.component";
import {DayComponent} from "./day/day.component";
import {englishLanguageGuard, germanLanguageGuard} from './core/guards/language-route.guard';
import {MoonInformationComponent} from './moon-information/moon-information.component';
import {PrivacyPolicyIosComponent} from './privacy-policy-ios/privacy-policy-ios.component';

const siteTimeZone = 'Europe/Berlin';

function currentSiteDateParts() {
    const parts = new Intl.DateTimeFormat('en', {
        timeZone: siteTimeZone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
    }).formatToParts(new Date());

    const values = Object.fromEntries(parts.map(part => [part.type, part.value]));
    return {
        year: values['year'],
        month: values['month'],
        day: values['day']
    };
}

const currentDayRedirect = () => {
    const date = currentSiteDateParts();
    return `day/${date.year}-${date.month}-${date.day}`;
};

const currentMonthRedirect = () => {
    const date = currentSiteDateParts();
    return `month/${date.year}-${date.month}`;
};

export const appRoutes: Routes = [
    {
        path: '',
        redirectTo: currentDayRedirect,
        pathMatch: 'full'
    },
    {
        path: 'day',
        redirectTo: currentDayRedirect,
        pathMatch: 'full'
    },
    {
        path: 'heute',
        redirectTo: currentDayRedirect,
        pathMatch: 'full'
    },
    {
        path: 'app/privacy_policy/ios',
        component: PrivacyPolicyIosComponent,
        canActivate: [germanLanguageGuard]
    },
    {
        path: 'en/app/privacy_policy/ios',
        redirectTo: '/app/privacy_policy/ios',
        pathMatch: 'full'
    },
    {
        path: 'app',
        component: MobileComponent,
        canActivate: [germanLanguageGuard]
    },
    {
        path: 'search',
        component: SearchComponent,
        canActivate: [germanLanguageGuard]
    },
    {
        path: 'information',
        component: MoonInformationComponent,
        canActivate: [germanLanguageGuard]
    }, {
        path: 'imprint',
        component: ImprintComponent,
        canActivate: [germanLanguageGuard]
    },
    {
        path: 'day/:currentDay',
        component: DayComponent,
        canActivate: [germanLanguageGuard]
    },
    {
        path: 'month/:currentMonth', component: MonthComponent, canActivate: [germanLanguageGuard]
    },
    {
        path: 'month',
        redirectTo: currentMonthRedirect,
        pathMatch: 'full'
    },
    {
        path: 'calendar/:currentMonth',
        redirectTo: route => `month/${route.params['currentMonth']}`
    },
    {
        path: 'calendar',
        redirectTo: currentMonthRedirect,
        pathMatch: 'full'
    },
    {
        path: 'details/:taskId',
        component: RecommendationDetailsComponent,
        canActivate: [germanLanguageGuard]
    },
    {
        path: 'en',
        canActivate: [englishLanguageGuard],
        canActivateChild: [englishLanguageGuard],
        children: [
            {
                path: '',
                redirectTo: currentDayRedirect,
                pathMatch: 'full'
            },
            {
                path: 'day',
                redirectTo: currentDayRedirect,
                pathMatch: 'full'
            },
            {
                path: 'app',
                component: MobileComponent
            },
            {
                path: 'search',
                component: SearchComponent
            },
            {
                path: 'information',
                component: MoonInformationComponent
            },
            {
                path: 'imprint',
                component: ImprintComponent
            },
            {
                path: 'day/:currentDay',
                component: DayComponent
            },
            {
                path: 'month/:currentMonth',
                component: MonthComponent
            },
            {
                path: 'month',
                redirectTo: currentMonthRedirect,
                pathMatch: 'full'
            },
            {
                path: 'calendar',
                redirectTo: currentMonthRedirect,
                pathMatch: 'full'
            },
            {
                path: 'details/:taskId',
                component: RecommendationDetailsComponent
            }
        ]
    }
];

